/*  ========================================================================
    # Scripts - Share Bar
    ========================================================================  */

import tailwindConfig from '../../../tailwind.config';

/**
 * Script that handles the fixed share bar on post pages.
 */
const ShareBar = {
  cfg: {
    hero: document.getElementById('hero'),
    relatedPosts: document.getElementById('related-posts'),
    shareBar: document.querySelector('.c-share-bar'),
    showClass: 'c-share-bar--show'
  },

  /**
   * Handle Share Bar behavior
   */
  handleShareBar() {
    const observer = new IntersectionObserver(elements => {
      elements.forEach(element => {
        if (
          !element.isIntersecting &&
          window.scrollY > this.cfg.hero.offsetHeight &&
          window.outerWidth > parseFloat(tailwindConfig.theme.screens.md)
        ) {
          this.cfg.shareBar.classList.add(this.cfg.showClass);
        } else {
          this.cfg.shareBar.classList.remove(this.cfg.showClass);
        }
      });
    });

    // Observe hero to trigger share bar
    observer.observe(this.cfg.hero);
    observer.observe(this.cfg.relatedPosts);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.hero) {
      this.handleShareBar();
    }
  }
};

export default ShareBar;
